/**
 * Copyright Mántum All Rights Reserved.
 */
import Checkbox from '../checkbox';
import { forwardRef } from 'react';

import type { Validation, Detail } from '@mantum/kanela';

export type PropTypes = {
    advanced?: {
        message?: string;
        action?: string;
    };
    disabled?: boolean;
    name?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (name?: string, value?: unknown) => void;
    optional?: boolean;
    placeholder?: string;
    testid?: string;
    validation?: Validation;
    value?: boolean;
};

export default forwardRef<Detail<unknown>, PropTypes>(
    function TermsAndConditions(props, ref) {
        // prettier-ignore
        const {
            advanced = {}
        } = props;

        // prettier-ignore
        const { 
            message = "I agree with the",
            action = "terms and conditions"
        } = advanced;

        const onChange = (name?: string, value?: unknown) => {
            if (props.onChange) {
                props.onChange(name, value);
                if (name) {
                    props.onChange(`${name}-text`, props.placeholder);
                }
            }
        };

        const onClick = () => {
            if (props.placeholder) {
                const file = new Blob([props.placeholder], {
                    type: 'text/plain'
                });

                const url = URL.createObjectURL(file);
                if (url) {
                    window.open(url, '_blank');
                }
            }
        };

        return (
            <Checkbox
                {...props}
                ref={ref}
                onChange={onChange}
                label={
                    <div className='truncate font-medium text-gray-900'>
                        <div className='mr-1 inline-block'>{message}</div>
                        <button
                            className='inline-block text-primary hover:underline'
                            onClick={onClick}
                            tabIndex={-1}
                            type='button'
                        >
                            {action}
                        </button>
                    </div>
                }
            />
        );
    }
);
